import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_TYPES_OF_VACCINATIONS,
    GET_VACCINATIONS,
    GET_VACCINATIOS_CURR,
    SET_MEDBLOCK_LOADING
} from "../types";

export const getVaccinations = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/c_vaccine`);
        dispatch({ type: GET_VACCINATIONS, payload: data });
    } catch (error) {
    }
};
// ТИП ВАКЦИНЫ (ВТОРАЯ МОДАЛКА)
// сами вакцины - короткий typesVaccinations:
export const getTypesOfVaccinations = () => async (dispatch, getState) => {
    dispatch({ type: SET_MEDBLOCK_LOADING, payload: true });
    try {
        const { data } = await api.get(`/c_vac_type`);
        dispatch({ type: GET_TYPES_OF_VACCINATIONS, payload: data });
    } catch (error) {
    }
    dispatch({ type: SET_MEDBLOCK_LOADING, payload: false });
};

// коетр прививка - длинная
export const getVaccinationsCurr = (id) => async (dispatch, getState) => {
    dispatch({ type: SET_MEDBLOCK_LOADING, payload: true });
    try {
        const { data } = await api.get(`/c_vaccine/${id} `);
        dispatch({ type: GET_VACCINATIOS_CURR, payload: data });
    } catch (error) {
    }
    dispatch({ type: SET_MEDBLOCK_LOADING, payload: false });
};

// сами вакцины - короткий
export const updateTypesOfVaccinations = (params) => async (dispatch, getState) => {
    try {
        await api.put(`/c_vac_type/${params.c_vac_type}`, params);
        await dispatch(getTypesOfVaccinations());
    } catch (error) {
    }
}
// сами вакцины - короткий
export const createTypesOfVaccinations = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/c_vac_type`, data);
        createNotification('success', 'Успешно');
        await dispatch(getTypesOfVaccinations());
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

// СЕЛЕКТ С КОРОТКИМИ ВАКЦИНАМИ typesVaccinations
export const createVaccine = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/c_vaccine`, data);
        await dispatch(getVaccinations());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

export const updateVaccine = (params) => async (dispatch, getState) => {
    try {
        await api.put(`/c_vaccine/${params.c_vac_type}`, params);
        await dispatch(getVaccinations());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось обновить запись");
    }
}

export const deleteTypesOfVaccinations = (id) => async (dispatch, getState) => {
    try {
        await api.delete(`/c_vac_type/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getTypesOfVaccinations());
    } catch (error) {
        createNotification('error', "Не удалось удалить запись");
    }
};

export const deleteVaccinations = (id) => async (dispatch, getState) => {
    try {
        await api.delete(`/c_vaccine/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getVaccinations());
    } catch (error) {
        createNotification('error', "Не удалось удалить запись");
    }
};